// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-closed-solid';

export const Component = () => (
  <path d='M0 21.636V9.855h24.521v11.78c0 .24-.096.48-.287.671a.837.837 0 0 1-.67.335H.957a.837.837 0 0 1-.67-.335.946.946 0 0 1-.288-.67ZM23.563 4.97H10.776l-.767-2.3C9.913 2.24 9.627 2 9.1 2H.958a.946.946 0 0 0-.67.288c-.192.24-.288.478-.288.718v5.89h24.521V5.928a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.287Z' />
);

export const viewBox = '0 0 25 25';
